import React from 'react';
import _ from 'lodash';

const stylesDoc = {
	type: 'string',
	children: {
		'font-family': {
			type: 'string',
			description: <>
				Accepts comma seperated list of fonts<br/>
				<div className="spacer">
					e.g. <br/>
					<code>Verdana</code><br/>
					<code>Gill Sans Extrabold, sans-serif</code><br/>
					<code>"Goudy Bookletter 1911", sans-serif</code>
				</div>
			</>
		},
		'font-weight': {
			type: 'string',
			description: <>
				Accepts integer weight, or a named constant<br/>
				<div className="spacer">
					e.g. <br/>
					<code>500</code> <code>1500</code><br/>
					<code>normal</code> <code>lighter</code> <code>bold</code> <code>bolder</code>
				</div>
			</>
		},
		'font-size': {
			type: 'string',
			description: <>
				Accepts decimal size followed by one of supported suffixes<br/>
				<code>px</code> <code>%</code>  <code>em</code> <code>rem</code> <code>ex</code>
				<code>vh</code> <code>vw</code> <code>vmin</code> <code>vmax</code> <code>ch</code>
				<code>cm</code> <code>mm</code> <code>in</code> <code>pc</code> <code>pt</code><br/>
				<div className="spacer">
					e.g. <br/>
					<code>1rem</code> <code>18px</code> <code>50%</code> <code>1.75pt</code>
				</div>
			</>
		},
		'color': {
			type: 'string',
			description: <>
				Accepts color name constants, hex codes, or rgb and rgba functions
				<div className="spacer">
					e.g. <br/>
					<code>red</code> <code>green</code>  <code>purple</code><br/>
					<code>#fff</code> <code>#ff00000</code><br/>
					<code>rgb(255, 0, 0)</code> <code>rgb(100%, 10%, 25%)</code><br/>
					<code>rgba(255, 136, 0, 0.1)</code> <code>rgba(100%, 10%, 25%, 50%)</code>
				</div>
			</>
		},
		'padding': {
			type: 'string',
			description: <>
				Accepts decimal size followed by one of supported suffixes, repeated up to 4 times<br/>
				<code>px</code> <code>%</code>  <code>em</code> <code>rem</code> <code>ex</code>
				<code>vh</code> <code>vw</code> <code>vmin</code> <code>vmax</code> <code>ch</code>
				<code>cm</code> <code>mm</code> <code>in</code> <code>pc</code> <code>pt</code><br/>
				<div className="spacer">
					e.g. <br/>
					<code>1rem</code> <code>18px</code> <code>10%</code> <code>1.75pt</code><br/>
					<code>1rem 0.5rem</code> <code>18px 14px</code> <code>10% 5%</code> <code>0.75pt 0.25pt</code><br/>
					<code>1rem 0.5rem 0.5rem 1rem</code> <code>18px 6px 14px 12px</code>
				</div>
			</>
		},
	}
};


const fieldDoc = (overrides) => _.merge({
	selector: {
		type: "string",
		description: "CSS selector identify the element to use a field"
	},
	placeholder: {
		type: "string",
		description: "Field placeholder"
	},
	label: {
		type: "string",
		description: "Screen reader label"
	},
	styles: {
		description: <>Field style overrides (see <a href="#Styling" >Styling</a>)</>,
		type: "object",
	},
}, overrides);

export {stylesDoc, fieldDoc};
